import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;

	> div {
		width: 100%;
		display: flex;
		gap: 1.5rem;
		align-items: center;
		justify-content: center;
	}
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: 100%;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;
